import React, { useState } from "react";
import { CardHeader, CardBody, Card, FormGroup, Label } from "reactstrap";
import FootprintInputText from "../../../Components/utils/FootprintInputText";
import FootprintInputCheckbox from "../../../Components/utils/FootprintInputCheckbox";
import { useRequestProcessor } from "../../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../../AtomStore/store";
import { Rating } from "react-simple-star-rating";
import { getSurveyParams } from "../../../QueryFunctions/queryfunction";
import { StyledMAinDiv } from "./styles";

const RIGHT_QUESTION = "What can we do for a better recommendation from you?";
const WRONG_QUESTION = "Please tell us what you like most about footprints.";

const Survey1 = ({ onRatingPressed, getTags, getComment }) => {
  const { useQueryWrapper } = useRequestProcessor();
  const [rating, SetRating] = useState(0);
  const [activeChild] = useAtom(activeChildDetail);
  const { data: questions } = useQueryWrapper(
    ["getSurveyParams", "survey" + activeChild?.id],
    () => getSurveyParams(activeChild)
  );

  const tooltipArray = [
    "Terrible",
    "Terrible+",
    "Bad",
    "Bad+",
    "Average",
    "Average+",
    "Great",
    "Great+",
    "Awesome",
    "Awesome+",
  ];

  const fillColorArray = [
    "#f17a45",
    "#f17a45",
    "#f19745",
    "#f19745",
    "#f1a545",
    "#f1a545",
    "#f1b345",
    "#f1b345",
    "#f1d045",
    "#f1d045",
  ];

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [state, setState] = useState({
    selectedRating: -1,
    dynamicQuestions: undefined,
  });
  const [selectedItem, setSelectedItem] = useState();

  // const ratingPressed = (rating) => {
  //   SetRating(rating);
  //   const newSelectedItem = questions.find(
  //     (item) =>
  //       rating <= parseInt(item.cat_max) && rating >= parseInt(item.cat_min)
  //   );

  //   const isCatKeyChanged = selectedItem?.cat_key !== newSelectedItem?.cat_key;

  //   setState((prev) => ({
  //     ...prev,
  //     selectedRating: rating,
  //   }));

  //   setSelectedItem(newSelectedItem);

  //   // Reset selected checkboxes if category changed
  //   if (isCatKeyChanged) {
  //     setSelectedCheckboxes({});
  //     if (getTags) getTags([]);
  //   }

  //   if (onRatingPressed) {
  //     onRatingPressed(rating);
  //   }
  // };
  const ratingPressed = (rating) => {
    const newSelectedItem = questions.find(
      (item) =>
        rating <= parseInt(item.cat_max) && rating >= parseInt(item.cat_min)
    );

    const isCatKeyChanged = selectedItem?.cat_key !== newSelectedItem?.cat_key;

    setSelectedItem(newSelectedItem);
    SetRating(rating);

    setState((prevState) => ({
      ...prevState,
      selectedRating: rating,
    }));
    setSelectedCheckboxes(isCatKeyChanged ? {} : selectedCheckboxes);

    // Reset selected checkboxes if category changed
    if (isCatKeyChanged) {
      if (getTags) getTags([]);
    }

    if (onRatingPressed) {
      onRatingPressed(rating);
    }
  };

  const handleCheckboxClick = (items) => {
    const selectedItems = items.filter((item) => item.checked);
    if (selectedItem) {
      const updatedSelections = {
        ...selectedCheckboxes,
        [selectedItem.cat_key]: selectedItems,
      };
      setSelectedCheckboxes(updatedSelections);

      if (getTags) {
        getTags(selectedItems);
      }
    }
  };

  console.log("Selelcted Checkbox", selectedCheckboxes);
  console.log("Selected Rating ", state.selectedRating);

  if (Array.isArray(questions) && questions.length > 0) {
    return (
      <StyledMAinDiv>
        <FormGroup>
          <legend className="col-form-label text-black">
            How likely you would recommend Footprints to your friends and
            colleagues?
          </legend>
          <div>
            <Rating
              size={30}
              transition
              showTooltip
              iconsCount={10}
              onClick={ratingPressed}
              tooltipArray={tooltipArray}
              rating={rating}
              fillColorArray={fillColorArray}
              SVGclassName="inline"
              tooltipClassName="mt-2 ml-7"
              initialValue={rating}
            />
          </div>
        </FormGroup>

        {state.selectedRating > 0 && selectedItem && (
          <Card className="mb-3 w-100 border-1 border-black rounded-sm">
            <CardHeader
              className="text-center h5 text-black border-black"
              style={{ lineHeight: "normal" }}
            >
              {selectedItem.cat_slug}
            </CardHeader>
            <CardBody>
              <FootprintInputCheckbox
                key={selectedItem.cat_key}
                data={selectedItem.data.map((item) => ({
                  value: item,
                  label: item.value,
                  checked: (
                    selectedCheckboxes[selectedItem.cat_key] || []
                  ).some((selected) => selected.value === item.value),
                }))}
                onClick={handleCheckboxClick}
              />
            </CardBody>
          </Card>
        )}

        <FormGroup className="w-100">
          {state.selectedRating !== -1 && (
            <div>
              <Label for="exampleText" className="text-black">
                {state.selectedRating < 9 ? RIGHT_QUESTION : WRONG_QUESTION}
              </Label>
              <FootprintInputText
                type="text"
                onChange={(text) => {
                  if (getComment) {
                    getComment(text);
                  }
                }}
              />
            </div>
          )}
        </FormGroup>
      </StyledMAinDiv>
    );
  }

  return <div />;
};

export default Survey1;
